import ConfirmModal from "../../../components/ConfirmModal";
import {useDispatch, useSelector} from "react-redux";
import { tryUpdateUsersState} from "../../../redux/slices/manageUserSlice";
import {setManageFeatureModals, tryDeleteFeature} from "../../../redux/slices/permissionSlice";

const FeatureConfirmModal = () => {

  const dispatch = useDispatch();
  const {modal, data} = useSelector((state => state.permission.modals.confirm));
  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);
  const isRemovePermission = !!data?.remove;


  const onConfirm = () => {

    dispatch(tryDeleteFeature());

  };


  return (
    <ConfirmModal
      title={isRemovePermission ? "Remove permission from feature" : "Delete Feature"}
      showModal={modal}
      setShowModal={() => dispatch(setManageFeatureModals())}
      disabled={editing}
      buttonLabel={isRemovePermission ? "Remove" : "Delete"}
      onConfirm={onConfirm}
    >
      {

        isRemovePermission ?
          <div>Are you sure you want to remove '
            <span className="font-bold">{data.remove.name}</span>' permission from the feature '<span className="font-bold">{data?.feature?.name}</span>'?
          </div>
          :
          <div>Are you sure you want to delete <span className="font-bold">{data?.feature?.name}</span> feature?</div>
      }


    </ConfirmModal>
  );
};

export default FeatureConfirmModal;
